/**
 * ThemeState
 * ------------------------
 * Minimal, framework-agnostic observable store holding the currently
 * active theme. Deliberately has no React/Vue/etc. dependency so it can
 * be wrapped by whatever the app's UI layer ends up being — a
 * ThemeProvider component simply subscribes to this.
 */
export class ThemeState {
    constructor() {
        this.state = {
            activeTheme: null,
            activeThemeId: null,
            isLoading: false,
            fellBackToDefault: false,
        };
        this.listeners = new Set();
    }
    getState() {
        return this.state;
    }
    setState(partial) {
        this.state = { ...this.state, ...partial };
        this.listeners.forEach((listener) => listener(this.state));
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }
}
export const themeState = new ThemeState();
